import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "space-y-4 text-left" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h4", { class: "text-sm font-medium text-gray-900" }, "Amendment letter (PDF)"),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "\n        Upload a PDF (max 7 MB). It is emailed to the person who completed the\n        form, with the covering email below, after a virus scan.\n      ")
], -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Recipient", -1);
const _hoisted_4 = {
    key: 0,
    class: "mt-1 text-sm text-gray-900"
};
const _hoisted_5 = {
    key: 0,
    class: "mt-1 space-y-2"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-2" }, "\n          No email is stored for the person who completed this form. Enter an\n          address manually — it will be recorded as entered manually on the send\n          history.\n        ", -1);
const _hoisted_7 = {
    key: 0,
    class: "text-sm text-red-600"
};
const _hoisted_8 = {
    key: 1,
    class: "text-sm text-red-600"
};
const _hoisted_9 = {
    key: 2,
    class: "rounded-md border border-gray-200 bg-gray-50 p-3"
};
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm font-medium text-gray-900" }, "Covering email", -1);
const _hoisted_11 = { class: "mt-2 text-sm text-gray-700" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", { class: "font-medium" }, "Subject:", -1);
const _hoisted_13 = { class: "mt-2 whitespace-pre-wrap font-sans text-sm text-gray-800" };
const _hoisted_14 = {
    key: 3,
    class: "text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md p-2"
};
const _hoisted_15 = {
    key: 4,
    class: "flex justify-end"
};
const _hoisted_16 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FileUploader = _resolveComponent("FileUploader");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", null, [
            _createElementVNode("dl", null, [
                _hoisted_3,
                _createTextVNode(),
                (_ctx.hasFormRecipient)
                    ? (_openBlock(), _createElementBlock("dd", _hoisted_4, _toDisplayString(_ctx.recipientEmail), 1))
                    : _createCommentVNode("", true)
            ]),
            _createTextVNode(),
            (!_ctx.hasFormRecipient)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                        id: "manual-amend-letter-email",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.manualRecipientEmail) = $event)),
                        type: "email",
                        name: "manualRecipientEmail",
                        autocomplete: "email",
                        placeholder: "hiring.manager@example.com",
                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md", { 'border-red-500': _ctx.recipientError }]),
                        onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.touchedManualEmail = true)),
                        onInput: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.emitAttachmentChange && _ctx.emitAttachmentChange(...args)))
                    }, null, 34), [
                        [_vModelText, _ctx.manualRecipientEmail]
                    ]),
                    _createTextVNode(),
                    _hoisted_6,
                    _createTextVNode(),
                    (_ctx.recipientError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.recipientError), 1))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true)
        ]),
        _createTextVNode(),
        (_ctx.shortId)
            ? (_openBlock(), _createBlock(_component_FileUploader, {
                key: 0,
                name: "amend-letter",
                files: _ctx.files,
                "document-short-id": _ctx.shortId,
                uploading: _ctx.uploading,
                "allowed-file-types": [..._ctx.allowedFileTypes],
                "allowed-extensions-hint": ".pdf",
                "max-file-size-bytes": _ctx.maxFileSizeBytes,
                "max-files": 1,
                "file-name-transform": _ctx.addDateSuffix,
                "show-macro-warning": false,
                onUpdateFiles: _ctx.handleUpdateFiles,
                onFileUploading: _cache[3] || (_cache[3] = ($event) => (_ctx.uploading = $event))
            }, null, 8, ["files", "document-short-id", "uploading", "allowed-file-types", "max-file-size-bytes", "file-name-transform", "onUpdateFiles"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, "\n      Document ID is missing, so the letter cannot be uploaded yet.\n    ")),
        _createTextVNode(),
        (_ctx.coveringEmail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.coveringEmail.subject), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("pre", _hoisted_13, _toDisplayString(_ctx.coveringEmail.text), 1)
            ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_14, "\n      The covering email cannot be previewed until the hiring manager name,\n      employee name, and your name are available.\n    ")),
        _createTextVNode(),
        (_ctx.showSendButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("button", {
                    type: "button",
                    class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500",
                    disabled: !_ctx.canSend || _ctx.sending || _ctx.uploading,
                    onClick: _cache[4] || (_cache[4] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSend && _ctx.handleSend(...args)))
                }, _toDisplayString(_ctx.sending ? 'Sending…' : 'Send letter'), 9, _hoisted_16)
            ]))
            : _createCommentVNode("", true)
    ]));
}
